module.exports = __webpack_public_path__ + "static/img12-7fe777b07bc8521230fee59fb31af855.jpg";